export enum EFeatureFlag {
  ACCOUNT_MANAGER_API = 'account-manager-api',
  GA_NOT_APPEARING_BUG = 'ga-not-appearing-bug',
  RELATED_POINTS = 'related-points',
  MULTI_STEP_DROPDOWN = 'multi-step-dropdown',
  SHOW_EMPTY_FOLDERS = 'show-empty-folders',
  RETRY_API_LOGIC = 'retry-api-logic',
  PUSH_NOTIFICATION_PREFERENCES = 'ps-3762-push-notification-preferences',
  COPY_MULTIPLE_POINTS = 'ps-4951-copy-multiple-points',
  TABLE_COLUMNS_SEARCH_BAR = 'ps-5025-table-columns-search-bar',
  FILTER_BY_ID = 'ps-5087-filter-by-id',
  BULK_IMPORT_POINTS_FROM_EXCEL = 'ps-4665-bulk-import-points-from-excel',
  LAZY_LOAD_LIBRARIES = 'ps-4779-lazy-load-libraries',
  CUSTOM_FIELD_GROUPS = 'ps-4603-custom-field-groups',
  REBRAND = 'ps-5157-rebrand-pinpoint',
  CONVERT_POINT_CARD = 'ps-5003-convert-point-card',
  DIGITAL_SIGNATURES = 'ps-5124-digital-signatures',
  REMOVE_LOGGED_ENDPOINT = 'ps-5547-remove-logged-endpoint',
  GET_CURRENT_USER_ENDPOINT = 'ps-5548-remove-self-endpoint-add-me-endpoint',
}
